import { defineMessages } from "react-intl";

export const userStatusMessages = defineMessages({
  userStatus: {
    id: "7yKZvp",
    defaultMessage: "User Status",
    description: "section header",
  },
  userDisableInstruction: {
    id: "K/gnGg",
    defaultMessage:
      "If you want to disable this User please uncheck the box below.",
  },
});
